import { Icon, type IconProps } from "@chakra-ui/react";

const BrandFullCheckIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect
				x="0.75"
				y="0.75"
				width="22.5"
				height="22.5"
				rx="11.25"
				fill={"currentColor"}
			/>
			<rect
				x="0.75"
				y="0.75"
				width="22.5"
				height="22.5"
				rx="11.25"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.0964 7.39016L9.93638 14.3002L8.03638 12.2702C7.68638 11.9402 7.13638 11.9202 6.73638 12.2002C6.34638 12.4902 6.23638 13.0002 6.47638 13.4102L8.72638 17.0702C8.94638 17.4102 9.32638 17.6202 9.75638 17.6202C10.1664 17.6202 10.5564 17.4102 10.7764 17.0702C11.1364 16.6002 18.0064 8.41016 18.0064 8.41016C18.9064 7.49016 17.8164 6.68016 17.0964 7.38016V7.39016Z"
				fill="white"
			/>
		</Icon>
	);
};

export default BrandFullCheckIcon;
